module.exports = __webpack_public_path__ + "img/fa-v2-solid-900.717283fb.svg";